module.exports = __webpack_public_path__ + "img/66.5f6f9d2e.jpg";